function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#da0000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9f0000"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-603.003 -2995.375)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M635.786,2995.747a10.886,10.886,0,0,1,7.342.611h0a10.9,10.9,0,0,0,9.042,0h0a10.9,10.9,0,0,1,13.394,3.589h0a10.9,10.9,0,0,0,7.831,4.521h0a10.9,10.9,0,0,1,9.806,9.806h0a10.9,10.9,0,0,0,4.521,7.83h0a10.9,10.9,0,0,1,3.589,13.4h0a10.9,10.9,0,0,0,0,9.042h0a10.9,10.9,0,0,1-3.589,13.4h0a10.9,10.9,0,0,0-4.521,7.831h0a10.9,10.9,0,0,1-9.806,9.8h0a10.9,10.9,0,0,0-7.831,4.521h0a10.9,10.9,0,0,1-13.394,3.589h0a10.909,10.909,0,0,0-9.042,0h0a10.9,10.9,0,0,1-13.4-3.589h0a10.9,10.9,0,0,0-7.831-4.521h0a10.9,10.9,0,0,1-9.806-9.8h0a10.9,10.9,0,0,0-4.521-7.831h0a10.9,10.9,0,0,1-3.589-13.4h0a10.9,10.9,0,0,0,0-9.042h0a10.9,10.9,0,0,1,3.589-13.4h0a10.9,10.9,0,0,0,4.521-7.83h0a10.9,10.9,0,0,1,9.806-9.806h0a10.9,10.9,0,0,0,7.831-4.521h0A10.88,10.88,0,0,1,635.786,2995.747Z",
  fill: "url(#a)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37.182,
  cy: 37.182,
  r: 37.182,
  transform: "translate(610.466 3002.838)",
  fill: "none",
  stroke: "#fbb03b",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M660.894,3056.829v1.4a1.742,1.742,0,0,0-1.668,1.737v1.962H657.8l-1.344-7.884a.576.576,0,1,0-1.135.193l1.3,7.691H633.645l1.529-7.675a.579.579,0,1,0-1.136-.224l-1.575,7.9h-4.9a.584.584,0,0,1-.579-.58v-7.211a13.613,13.613,0,0,1,13.6-13.59h.085a.587.587,0,0,1,.517.317l4.046,7.953,4.046-7.953a.588.588,0,0,1,.518-.317h.123a13.525,13.525,0,0,1,3.4.432,1.748,1.748,0,0,0-1.56,1.73,11.592,11.592,0,0,0,3.66,8.494,9.229,9.229,0,0,0,2.177,3.474A10.169,10.169,0,0,0,660.894,3056.829Z",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.322,3014.716a2.088,2.088,0,0,0-1.791,3.181l-4.185,4.5-3.413-4.355a2.054,2.054,0,0,0,.409-1.228,2.1,2.1,0,0,0-4.2,0,2.061,2.061,0,0,0,.409,1.228l-3.413,4.355-4.185-4.509a2.094,2.094,0,1,0-1.86,1.019l2.524,9.953v2.324a.5.5,0,0,0,.039.185c-.008.116-.015.224-.015.34a8.613,8.613,0,1,0,17.226,0c0-.116-.008-.224-.015-.34a.743.743,0,0,0,.038-.185v-2.44l2.5-9.837a2.1,2.1,0,0,0-.07-4.193Zm-11.08,24.469a7.473,7.473,0,0,1-7.443-7.42h14.91A7.483,7.483,0,0,1,645.242,3039.185Z",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M665.4,3048.667l.232,1.382c-1.883-.956-1.123-.958-3.019,0,.134-1.131.434-1.547.069-1.891l-1-.989,1.39-.2c.5-.059.486-.548,1.058-1.575.588,1.047.58,1.516,1.058,1.575l1.39.2-1.012.989A.569.569,0,0,0,665.4,3048.667Z",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M674.73,3042.135h-2.54V3041.1a.584.584,0,0,0-.579-.579h-14.98a.584.584,0,0,0-.579.579v1.035H653.5a.583.583,0,0,0-.579.579,10.387,10.387,0,0,0,3.506,7.837,8.057,8.057,0,0,0,1.984,3.3,8.185,8.185,0,0,0,2.9,1.853,1.2,1.2,0,0,1,.741,1.12v2.563h-1.089a.583.583,0,0,0-.579.579v1.3h7.474v-1.3a.583.583,0,0,0-.579-.579H666.19v-2.563a1.187,1.187,0,0,1,.726-1.12,8,8,0,0,0,4.888-5.142,10.4,10.4,0,0,0,3.505-7.853A.583.583,0,0,0,674.73,3042.135Zm-20.631,1.158h1.953v4.849c0,.116,0,.24.008.355A9.308,9.308,0,0,1,654.1,3043.293Zm12.485,5.482c.016.078.409,2.255.409,2.332a.6.6,0,0,1-.864.517l-2.008-1.057c-1.776.826-2.131,1.374-2.625,1.011a.6.6,0,0,1-.232-.571l.386-2.239c-1.359-1.46-1.961-1.606-1.768-2.178.17-.579.826-.355,2.718-.718.942-1.722.9-2.363,1.521-2.363a.58.58,0,0,1,.517.325l1.012,2.038,2.247.324a.591.591,0,0,1,.471.394C668.545,3047.192,667.912,3047.347,666.584,3048.775Zm5.6-.285c.008-.116.008-.232.008-.348v-4.849h1.946A9.325,9.325,0,0,1,672.182,3048.49Z",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("rect", {
  width: 9.802,
  height: 2.284,
  transform: "translate(659.219 3062.432)",
  fill: "#fbb03b"
}));

var SvgKing = function SvgKing(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89.29,
    height: 89.29,
    viewBox: "0 0 89.29 89.29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKing, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/king.7bfedcf7.svg";
export { ForwardRef as ReactComponent };